import { GridValidRowModel } from "@mui/x-data-grid-pro";

const PatMonitoringExampleRows : GridValidRowModel[] = [
    {
      id: 1,     
      field0: "Hasta Adı Soyadı",
      field1: "fielda",
      field2: "fieldb",
      field3: "fieldc",
      field4: "fieldd",
      field5: "fielde",
      date: "14.08.2024",
      update: "updatg",
      delete: "deleth",
    },
    {
      id: 2,
      field0: "Hasta Adı Soyadı",
      field1: "fieldj",
      field2: "fieldk",
      field3: "fieldl",
      field4: "fieldm",
      field5: "fieldn",
      date: "14.08.2024",
      update: "updatü",
      delete: "14.08.2024",
    },
    {
      id: 3,
      field0: "Hasta Adı Soyadı",
      field1: "fields",
      field2: "fieldd",
      field3: "fieldg",
      field4: "fieldv",
      field5: "fieldc",
      date: "14.08.2024",
      update: "updatx",
      delete: "deletv",
    },
    {
      id: 4,
      field0: "Hasta Adı Soyadı",
      field1: "field23",
      field2: "field46",
      field3: "field56",
      field4: "field43",
      field5: "field52",
      date: "14.08.2024",
      update: "update2",
      delete: "delete3",
    },
  ];


  export default PatMonitoringExampleRows;